import PropTypes from 'prop-types';
import React from 'react';
import { SelectSearch } from 'mol-ui';
import { formatOptions } from 'shared/utils';
import { useSelector } from 'hooks';
import { useTranslation } from 'react-i18next';

const LicenseReasonPicker = ({
    allowNone = false,
    disabled,
    effective,
    hasError = false,
    margin,
    objectChange = false,
    onChange,
    placeholder,
    value
}) => {

    const { t } = useTranslation();
    const {
        configurations: {
            licenses
        }
    } = useSelector('config');

    const filteredLicenses = () => {
        if (effective === undefined) return licenses;
        return licenses.filter(({ effective_license }) => !!effective_license === effective);
    };

    const parsedOptions = [
        ...(allowNone ? [{ id: 0, label: 'Todos los motivos' }] : []),
        ...formatOptions(filteredLicenses(), 'label', 'id')
    ];

    const handleChange = value => {
        if (!objectChange) {
            onChange(value);
        } else {
            onChange(parsedOptions.find(({ id }) => id === value));
        }
    };

    const selectProps = {
        hasError,
        margin,
        value
    };

    return (
        <SelectSearch
            { ...selectProps }
            disabled={ disabled }
            options={ parsedOptions }
            placeholder={ placeholder ?? t('Seleccione el motivo de la licencia') }
            width="100%"
            onChange={ handleChange }
        />
    );
};

LicenseReasonPicker.propTypes = {
    allowNone: PropTypes.bool,
    disabled: PropTypes.bool,
    effective: PropTypes.bool,
    hasError: PropTypes.bool,
    margin: PropTypes.string,
    objectChange: PropTypes.bool,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    value: PropTypes.number
};

export default LicenseReasonPicker;
